import { getMonaco } from './monacoProvider';
import { measureLeadingComments } from './script';
const formatOptions = {
  IndentSize: 2,
  ConvertTabsToSpaces: true,
  // 在逗号分隔符后插入空格
  InsertSpaceAfterCommaDelimiter: true,
  // 在控制流语句中的关键字后插入空格
  InsertSpaceAfterKeywordsInControlFlowStatements: true,
  // 非空括号之前插入空格
  InsertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis: false,
  // 在 For 语句中的分号后插入空格
  InsertSpaceAfterSemicolonInForStatements: true,
  // 在二元运算符前后插入空格
  InsertSpaceBeforeAndAfterBinaryOperators: true
};

/**
 * @param {string} js
 * @return {Promise<string>}
 */
export async function formatCodeWithMonaco(js) {
  const monaco = await getMonaco();
  if (!monaco) throw new Error('monaco not available');
  const leadingLen = measureLeadingComments(js);
  const hasFakeReturn = js[leadingLen] === '{';

  // eslint-disable-next-line no-param-reassign
  if (hasFakeReturn) js = `${js.slice(0, leadingLen)}return/*valueTempMark*/${js.slice(leadingLen)}`;
  const file = monaco.editor.createModel(js, 'javascript', `file:///temp${Math.random()}.js`);
  try {
    const jsWorker = await monaco.languages.typescript.getJavaScriptWorker();
    const fileProxy = await jsWorker(file.uri);
    const changes = await fileProxy.getFormattingEditsForDocument(file.uri, formatOptions);
    let formattedCode = applyMonacoChanges(file.getValue(), changes);

    // TODO: ensure that `return {` not occurs in comment
    if (hasFakeReturn) formattedCode = formattedCode.replace(/return\/\*valueTempMark\*\/\s?/, '');
    return formattedCode;
  } catch (e) {
    return js;
  } finally {
    file.dispose();
  }
}
function applyMonacoChanges(orig, changes) {
  let result = orig;
  for (let i = changes.length - 1; i >= 0; i--) {
    const change = changes[i];
    const head = result.slice(0, change.span.start);
    const tail = result.slice(change.span.start + change.span.length);
    result = head + change.newText + tail;
  }
  return result;
}
//# sourceMappingURL=monaco.js.map
